/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_TitleInputs */

const en_pc_alt_misfit_title = /** @type {(inputs: Pc_Alt_Misfit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where it falls short today`)
};

const zh_pc_alt_misfit_title = /** @type {(inputs: Pc_Alt_Misfit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前的不足`)
};

/**
* | output |
* | --- |
* | "Where it falls short today" |
*
* @param {Pc_Alt_Misfit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_title = /** @type {((inputs?: Pc_Alt_Misfit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_title(inputs)
	return zh_pc_alt_misfit_title(inputs)
});
export { pc_alt_misfit_title as "pc.alt.misfit_title" }